import React from "react";
import error from "../images/error.svg";

export const Error = () => (
  <div className="flex flex-1 items-center justify-center">
    <img className="w-32" alt="error" src={error} />
  </div>
);
